const axios = require("axios");

const prabhupay = async (params) => {
  try {
    const response = await axios.post(
      process.env.REACT_APP_PRABHU_PAY_URL,
      params
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};

export { prabhupay };
